import { apiClient } from './client';
import type {
  SheetMirrorEditResult,
  SheetMirrorMonthDto,
  SheetMirrorMonthlyGroup,
  SheetMirrorTabDto,
  SheetMirrorTabKey,
} from '@bhops/shared';

// 구글 시트 탭 거울(2026-10-23) — BUSINESS '데모-계약 전환'. 고친 칸 · 새 줄은 곧바로 시트에 가지
// 않는다: 서버에 쌓였다가 시트의 앱스 스크립트가 1분 안에 가져가 시트에 쓴다(정본은 시트).
export const sheetMirrorApi = {
  async get(tab: SheetMirrorTabKey): Promise<SheetMirrorTabDto> {
    const { data } = await apiClient.get<SheetMirrorTabDto>(`/sheet-mirror/${tab}`);
    return data;
  },

  /** 달 탭 목록(자동 IB) — 최근 달 먼저. */
  async months(group: SheetMirrorMonthlyGroup): Promise<SheetMirrorMonthDto[]> {
    const { data } = await apiClient.get<SheetMirrorMonthDto[]>(`/sheet-mirror/groups/${group}`);
    return data;
  },

  /** 칸 고치기 — expected 는 고치기 전 화면에서 본 값(그사이 시트가 바뀌었으면 409). */
  async update(
    tab: SheetMirrorTabKey,
    rowKey: string,
    changes: Record<string, string>,
    expected: Record<string, string>,
  ): Promise<SheetMirrorEditResult> {
    const { data } = await apiClient.patch<SheetMirrorEditResult>(
      `/sheet-mirror/${tab}/rows/${encodeURIComponent(rowKey)}`,
      { changes, expected },
    );
    return data;
  },

  /** 새 줄 — 시트 맨 아래 데이터 줄 다음에 쓰인다. */
  async append(
    tab: SheetMirrorTabKey,
    values: Record<string, string>,
  ): Promise<SheetMirrorEditResult> {
    const { data } = await apiClient.post<SheetMirrorEditResult>(`/sheet-mirror/${tab}/rows`, {
      values,
    });
    return data;
  },
};
